/* @flow */

import * as INTERFACE from './interface';
export * from './interface';
export default INTERFACE;



// WEBPACK FOOTER //
// ./~/cross-domain-safe-weakmap/src/index.js